import React, { useEffect, useState } from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
import { useSelector } from 'react-redux';
import publicImage from '../../../utils/publicImage';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css';
import { getProduct } from '../../../services';
import { Variant } from '../../../constants/variants';
import {
  SUPPORTED_IMAGE_FORMAT,
  CAROUSEL_PRODUCT_ENABLED,
  CAROUSEL_PRODUCT_ID
} from '../../../constants';
import { useSearchParams } from 'react-router-dom';
import localesReplacement from '../../../utils/localesReplacement';

const cx = classnames.bind(style);

const castrolImages = [
  publicImage("carousels-02.jpg"),
  publicImage("carousels-01.jpg"),
  publicImage("carousels-02.jpg"),
].map((item) => {
  return {
    title: "Find the right Oil",
    description:
      "With the Castrol Product Finder it has never been easier to find out which engine oil is best for you. Please enter required information to start your search.",
    link: item,
  };
});

const fordImages = [
  publicImage("ford-carousels-02.png"),
  publicImage("ford-carousels-03.png"),
  publicImage("ford-carousels-04.png"),
].map((item) => {
  return {
    title: "Find the right Engine Oil",
    description:
      "With the Engine Oil Selector it has never been easier to find out which engine oil is best for you. Please enter required information to start your search.",
    link: item,
  };
});


function Carousels() {
  const replacements = useSelector((state: any) => state.replacements);
  const country = useSelector((state: any) => state.country);
  const [ params ] = useSearchParams();


  const variant = params.get('variant');
  const isFord = variant === Variant.FORD;
  const [ data, setData ] = useState(isFord ? fordImages : castrolImages);

  useEffect(() => {
    if (CAROUSEL_PRODUCT_ENABLED) {
      getProduct(CAROUSEL_PRODUCT_ID).then((data) => {
        if (data.status !== 200) {
          setData(isFord ? fordImages : castrolImages);
          return;
        }
        const response = (data.data as any).links.map((item: any) => {
          const parts = item.displayText.split('🚗');
          return {
            variant: parts.at(0),
            title: parts.at(1),
            description: parts.at(2),
            link: item.link
          }
        }).filter((item: any) => !variant || item.variant.toLowerCase().search(variant) >= 0);

        if (response.length > 0) {
          setData(response);
        }
      }).catch((_) => {
        setData(isFord ? fordImages : castrolImages);
      });      
    }
  }, [country]);

  const isImage = (link: string) => {
    return SUPPORTED_IMAGE_FORMAT.some((format: string) => link.endsWith(format));
  }

  const isVideo = (link: string) => {
    return link.endsWith('mp4');
  }

  const playVideo = (link: string) => {
    return (
      <>
        <video width="100%" height="auto" controls autoPlay>
          <source src={link} type="video/mp4" />
        </video>
      </>
    )
  }

  return (
    <Swiper
      loop={true}
      pagination={{
        clickable: true,
      }}
      autoplay={{
        delay: 4000,
        pauseOnMouseEnter: true,
        disableOnInteraction: true,
      }}
      modules={[Autoplay, Pagination, Navigation]}
      navigation={true}
      className={cx('slider')}
    >
      { data.map((item: any, i) => {
        return (
          <SwiperSlide key={item.title + i}>
            <div className={cx('item')}>
              {isImage(item.link) ? (<img className={cx('carousel-image')} src={item.link} />) : isVideo(item.link) ? playVideo(item.link) : <></> }
              <div className={cx('mask')}>
                <strong>{localesReplacement(replacements, item.title)}</strong>
                <p>
                  {localesReplacement(replacements, item.description)}
                </p>
              </div>
            </div>
          </SwiperSlide>
        )
      })}
    </Swiper>
  );
}

export default Carousels;
